import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./sections/About";
import Cta from "./sections/Cta";
import Hero from "./sections/Hero";
import HowItWorks from "./sections/HowItWorks";
import WhyChoose from "./sections/WhyChoose";
import FAQ from "./sections/FAQ";

export default function Home() {
  const [activeSection, setActiveSection] = useState("hero");

  useEffect(() => {
    const handleScroll = () => {
      // Find the section that is currently in the viewport
      const sections = [
        "hero",
        "about",
        "why-us",
        "whyus",
        "how-it-works",
        "faq",
      ];
      for (const sectionId of sections) {
        const section = document.getElementById(sectionId);
        if (section) {
          const rect = section.getBoundingClientRect();
          const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;

          if (rect.top <= windowHeight / 2 && rect.bottom >= windowHeight / 2) {
            if (activeSection !== sectionId) {
              setActiveSection(sectionId);
            }
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeSection]);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);

    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [isHomePage, setIsHomePage] = useState(true);
  useEffect(() => {
    if (window.location.pathname === "/#" || window.location.pathname === "/") {
      setIsHomePage(true);
    } else {
      setIsHomePage(false);
    }
  }, [isHomePage]);
  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isHomePage]);

  return (
    <div className="home">
      <Header scrollToSection={scrollToSection} activeSection={activeSection} />

      <Hero />
      <About />
      {/* <Team /> */}
      <WhyChoose />
      <HowItWorks />
      <Cta />
      <FAQ />
      {/* <GetInTouch /> */}
      <Footer />
    </div>
  );
}
